import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, GoogleCalendar, GoogleCalendarWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateGoogleCalendar({
  googleCalendarId,
}: {
  googleCalendarId: string;
}): UseMutationResult<AxiosResponse<GoogleCalendar>, AxiosError<ErrorMessage>, GoogleCalendarWrite> {
  const queryClient = useQueryClient();

  const updateGoogleCalendar = (payload: GoogleCalendarWrite): Promise<AxiosResponse<GoogleCalendar>> => {
    return client.put(`google-calendars/${googleCalendarId}/`, payload);
  };

  return useMutation(updateGoogleCalendar, {
    onSuccess: () => {
      queryClient.invalidateQueries(['google-calendars']);
    },
  });
}
